<template>
  <div class="activity618" id="activity618">
    <AppHeader/>
  	<div class="bg-box">
      <div class="bg-1"></div>
      <div class="bg-2"></div>
      <div class="bg-3"></div>
      <div class="bg-4"></div>
    </div>
    <div class="body-content">
      <div class="ctn-box">

        <div class="panel-box pn1">
          <div class="c-box">
            <div class="top-text">
              大智慧365简单好用的炒股利器，沪深level-2、全息盘口等核心功能直击主力买卖，为您提供多种特色数据服务！
            </div>
            <div class="tag-list">
              <span class="tag-item"  v-for="(item,index) in tabtitles" :class="{active:tabSelectedIndex==index}" @click="tabSelectedIndex=index">{{item}}</span>
            </div>
            <div class="img-list-box">
              <div class="img-box" v-for="(item,index) in imgList" :class="{active:tabSelectedIndex==index}">
                <img :src="item"/>
              </div>
            </div>
            <div class="buy-btn" @click="goUrl(116)">
              <div class="btn-ctn">
                <span class="white-font"><span class="big-f">618</span>元/年</span>
                <span class="y-font">立即购买&nbsp;&gt;</span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-box pn2">
          <div class="c-box">
            <div class="clearfix pn2-topbox">
              <span class="left-box">
                <div class="top-tle">大智慧专业版</div>
                <div class="l-list">
                  <span>个性化编写选股策略</span>
                  <span>智能复盘利器</span>
                  <span>DDE决策系统</span>
                </div>
                <div class="price-box">
                  <span class="big-font">2680</span>
                  元/年
                </div>
              </span>

              <span class="right-box">
                <div class="top-tle">大智慧APP</div>
                <div class="l-list">
                  <span>沪深 LEVEL-2 手机版</span>
                </div>
                <div class="price-box">
                  <span class="big-font">58</span>
                  元/年
                </div>
              </span>
            </div>
            <div class="buy-btn" @click="goUrl(3048)">
              <div class="btn-ctn">
                <span class="white-font">PC+移动L2 仅需2680元/年</span>
                <span class="y-font">立即购买&nbsp;&gt;</span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-box pn3">
          <div class="c-box">
            <div class="top-text">【特色功能】大势研判  热点风向 优选500  赢在开盘  专属直播课</div>
            <div class="img-box"></div>
            <div class="btm-text">注意：本产品仅限大智慧APP使用；大智慧策略投资终端，老用户购买优选大师财富版不赠送大智慧财富版年卡。</div>
            <div class="buy-btn" @click="goUrl(197)">
              <div class="btn-ctn">
                <span class="white-font"><span class="big-f">16800</span>元/年</span>
                <span class="y-font">立即购买&nbsp;&gt;</span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-box pn4">
          <div class="c-box">
            <div class="top-text">
              <p>
                <span class="y-font">【策略智慧礼包】</span>内容：策略投资终端一年+优选大师财富版一年+移动18指标一年
              </p>
              <p>
                其中<span class="y-font">【18个移动指标】</span>包含：云梯通道、双突战法、神奇D信号、九转交易、主力筹码追踪、黄金通道、波段王、白马智投、蓄势待发、追击反转、尾盘动能、资金搏击、题材王、异动查、情绪转点、机构热股、抢筹先锋、分时顶底，不可叠加。
              </p>
            </div>
            <div class="clearfix pn2-topbox">
              <span class="left-box">
                <div class="top-tle">大智慧策略投资终端</div>
                <div class="l-list">
                  <span>特色ACE决策系统</span>
                  <span>个股评分系统</span>
                </div>
              </span>
              <span class="right-box">
                <div class="top-tle">大智慧APP</div>
                <div class="l-list">
                  <span>优选大师财富版(移动端)</span>
                  <span>大智慧APP指标（18个）</span>
                </div>
              </span>
            </div>
            <div class="btm-text">注意：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动18个相关同类型指标的客户,不可与本礼包中包含的18个移动指标叠加使用。</div>
            <div class="buy-btn" @click="goUrl(3041)">
              <div class="btn-ctn">
                <span class="white-font"><span class="big-f">56000</span>元/年</span>
                <span class="y-font">立即购买&nbsp;&gt;</span>
              </div>
            </div>
          </div>
        </div>

        <div class="footbtm-text">
          活动须知：《大智慧365》、《大智慧专业版》、《大智慧策略投资终端》 、《优选大师财富版》双年卡，季卡，月卡均不参与活动，大智慧策略投资终端，老用户购买优选大师财富版不赠送大智慧财富版年卡
        </div>
        <div class="footbtm-tip">投资有风险，入市需谨慎</div>

      </div>
    </div>
  </div>
</template>


<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
	name: 'activity618',
  components: {
    AppHeader,
  },
  data () {
    return {
        token: '',
        tabtitles:[
          '全推Level-2','四维战法','北向资金','热点轮动'
        ],
        tabSelectedIndex:0,
        imgList:[
          require("@/assets/images/activity/activity618/img1.png"),
          require("@/assets/images/activity/activity618/img2.png"),
          require("@/assets/images/activity/activity618/img3.png"),
          require("@/assets/images/activity/activity618/img4.png"),
        ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {


  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
$url:'../../assets/images/activity/activity618/';
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
$color:#7c35ff;
body{

}

.activity618{
  position: relative;
  z-index: 1;
	.bg-box{
		position: absolute;
    top: 100px;
    width: 100%;
    left: 0;
    z-index: -1;
   // background: linear-gradient(180deg, #02B8EA 0%, #2A78CD 100%);
    div[class^="bg-"]{
      width: 100%;
      background-position: top center;
      background-repeat: no-repeat;
      background-size: 1200px auto;
    }
    .bg-1{
      height: 811px;
      background-image: url($url+'bg1.jpg');
    }
    .bg-2{
      height: 853px;
      background-image: url($url+'bg2.jpg');
    }
    .bg-3{
      height: 1278px;
      background-image: url($url+'bg3.jpg');
    }
    .bg-4{
      height: 1140px;
      background-image: url($url+'bg4.jpg');
    }
	}
	.body-content{
    padding-top: 826px;
		.ctn-box{
      .panel-box{

        .c-box{
          display: block;
          margin: 0 auto;
          width: 755px;
          padding: 0 42px;
          box-sizing: border-box;
          .buy-btn{
            margin-top: 26px;
            width: 100%;
            height: 80px;
            box-shadow: 6px 7px 5px 0px rgba(171, 181, 254, 0.41);
            border-radius: 40px;
            text-align: center;
            position: relative;
            z-index: 1;
            cursor: pointer;
            &:before{
              content: '';
              position: absolute;
              background: linear-gradient(to right, rgba(255, 255, 255, 0.63), rgba(255, 239, 210, 0.63));;
              //background: linear-gradient(115deg, rgba(255, 255, 255, 0.63), rgba(255, 239, 210, 0.63)) 3 3;
              width: 100%;
              border-radius: 40px;
              height: 100%;
              padding: 3px;
              top: -3px;
              left: -3px;
              z-index: -1;
            }
            .btn-ctn{
              z-index: 1;
              width: 100%;
              height: 100%;
              border-radius: 40px;
              background: linear-gradient(90deg, #F9935C, #E65068, #F2546D);
              padding-top: 17px;
              box-sizing: border-box;
            }
            .white-font{
              font-size: 34px;
              color: #FFFFFF;

              .big-f{
                font-size: 50px;
                line-height: 42px;
                padding-right: 8px;
              }
            }
            .y-font{
              font-size: 34px;
              color: #FEE700;
              padding-left: 40px;
            }
            &:hover{
              opacity: 0.85;
            }
          }
          .pn2-topbox{
            .left-box,.right-box{
              display: inline-block;
              float: left;
              .top-tle{
                font-size: 30px;
                color: #FFFFFF;
                line-height: 30px;
                padding: 26px 0 35px 45px;
              }
              .l-list{
                padding-left: 86px;
                span{
                  display: block;
                  font-size: 22px;
                  color: #D3E3F0;
                  line-height: 21px;
                  padding-bottom: 16px;
                }
              }
              .price-box{
                width: 201px;
                height: 60px;
                border-radius: 5px;
                margin-top: 8px;
                margin-left: 44px;
                font-size: 18px;
                color: #FED031;
                box-sizing: border-box;
                padding: 13px 0 0 16px;
                .big-font{
                  font-size: 46px;
                  color: #FED031;
                  line-height:36px;

                }
              }
            }
            .left-box{
              width: 366px;
              height: 292px;
              border-radius: 20px;
              margin-right: 24px;
            }

            .right-box{
              width: 280px;
              height: 292px;
              .top-tle{
                padding: 26px 0 36px 26px;
              }
              .l-list{
                padding-left: 63px;
              }
              .price-box{
                margin-top: 80px;
                margin-left: 26px;
              }
            }
          }

        }
        &.pn1{
          padding-top: 30px;
          box-sizing: border-box;
          .c-box{
            height: 807px;
            padding-top: 104px;
          }
          .top-text{
            font-size: 24px;
            color: #E0EDF7;
          }
          .tag-list{
            padding-top: 26px;
            .tag-item{
              display: inline-block;
              min-width: 145px;
              height: 42px;
              cursor: pointer;
              box-sizing: border-box;
              background: #3A9EDE;
              border-radius: 10px;
              margin-right: 20px;
              font-size: 24px;
              line-height: 42px;
              color: #FFFFFF;
              text-align: center;
              padding: 0 12px;
              text-shadow: 4px 0px 5px #0964b1;

              &.active{
                background: linear-gradient(-31deg, #42CCCE, #30AFDE);
                box-shadow: 0px 16px 5px 0px #1f67b9;
                border-radius: 10px;
              }
            }
          }
          .img-list-box{
            margin-top: 34px;
            .img-box{
              width: 100%;
              height: 379px;
              display: none;
              border-radius: 10px;
              overflow: hidden;
              img{
                max-width: 100%;
              }
              &.active{
                display: block;
              }
            }
          }
        }
        &.pn2{
          padding-top: 49px;
          .c-box{
            padding-top: 103px;
            height: 551px;
          }
          .buy-btn{
            margin-top: 35px;
            .white-font{
              font-size: 32px;
              .big-f{}
            }
            .y-font{
              padding-left: 14px;
            }
          }
        }
        &.pn3{
          padding-top: 50px;
          .c-box{
            padding-top: 114px;
            height: 628px;
            .top-text{
              font-size: 24px;
              color: #E0EDF7;
              line-height: 24px;
            }
            .img-box{
              width: 100%;
              height: 231px;
              background: url($url+'pn3img.jpg')no-repeat center/100%;
              border-radius: 10px;
              overflow: hidden;
              margin: 36px auto 22px;
            }
            .btm-text{
              font-size: 20px;
              color: #FFFFFF;
              opacity: 0.6;
            }
            .buy-btn{
              margin-top: 29px;
            }
          }
        }
        &.pn4{
          padding-top: 62px;
          .c-box{
            padding-top: 104px;
            height: 853px;
          }
          .top-text{
            p{
              font-size: 24px;
              color:#E0EDF7;
              width: 684px;
              margin-bottom: 36px;

              margin-bottom: 32px;
              line-height: 38px;
              .y-font{
                color: #FED031;
              }
            }
          }
          .pn2-topbox{
            .left-box,.right-box{
              width: 329px;
              height: 197px;
            }
            .left-box{
              margin-right: 29px;
              .top-tle{
                padding-left: 33px;
              }
              .l-list{
               padding-left: 74px;
              }
            }
            .right-box{
              width: 313px;
              .top-tle{
                padding-left: 26px;
              }
              .l-list{
               padding-left: 63px;
              }
            }
          }
          .btm-text{
            font-size: 20px;
            color: #FFFFFF;
            opacity: 0.6;
            margin-top: 37px;
          }
        }
      }
      .footbtm-text{
        font-size: 24px;
        color: #000000;
        line-height: 32px;
        width: 746px;
        display: block;
        text-align: left;
        margin: 34px auto 43px;
      }
      .footbtm-tip{
        font-size: 28px;
        color: #ABC3E6;
        line-height: 31px;
        text-align: center;
        padding-bottom: 10px;
      }
      .footer-box{
        
      }
    }
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/activity/activity618.vue